module.exports = __webpack_public_path__ + "static/email-icon-493a4362f91c065809f2cb0a4a22d125.png";